<template>
    <div>
        <b-modal
            :visible="visible"
            id="link-modal"
            size="lg"
            ok-title="Add Link"
            @cancel="cancel"
            @close="cancel"
            @ok.prevent="save"
            :ok-disabled="!fieldsFilled"
        >
            <template #modal-title>
                Add Link
            </template>
            <div>
                <b-form-group label="Name" label-for="link-modal-name">
                    <b-form-input
                        id="link-modal-name"
                        type="text"
                        placeholder="Enter Name"
                        aria-label="name"
                        v-model="editable_name"
                        required
                    />
                </b-form-group>

                <b-form-group label="URL" label-for="link-modal-url">
                    <b-form-input
                        id="link-modal-url"
                        type="text"
                        placeholder="Enter URL"
                        aria-label="url"
                        v-model="editable_url"
                        required
                    />
                </b-form-group>

                <b-form-group label="Thumbnail">
                    <hr>
                    <div v-if="hasThumbnail" class="row">
                        <div class="col-6">
                            <b-form-group label="Title">
                                <b-form-input
                                    id="link-modal-thumbnail-title"
                                    type="text"
                                    placeholder="Enter Thumbnail Title"
                                    aria-label="thumbnail-title"
                                    v-model="editable_thumbnail.title"
                                />
                            </b-form-group>

                            <b-form-group label="Description">
                                <b-form-input
                                    id="link-modal-thumbnail-description"
                                    type="text"
                                    placeholder="Enter Thumbnail Description"
                                    aria-label="thumbnail-description"
                                    v-model="editable_thumbnail.description"
                                />
                            </b-form-group>

                            <b-form-group label="Alt">
                                <b-form-input
                                    id="link-modal-thumbnail-alt"
                                    type="text"
                                    placeholder="Enter Thumbnail Alt"
                                    aria-label="thumbnail-alt"
                                    v-model="editable_thumbnail.alt"
                                />
                            </b-form-group>

                            <b-form-group label="Caption">
                                <b-form-input
                                    id="link-modal-thumbnail-caption"
                                    type="text"
                                    placeholder="Enter Thumbnail Caption"
                                    aria-label="thumbnail-caption"
                                    v-model="editable_thumbnail.caption"
                                />
                            </b-form-group>

                            <b-form-group label="Credit">
                                <b-form-input
                                    id="link-modal-thumbnail-credit"
                                    type="text"
                                    placeholder="Enter Thumbnail Credit"
                                    aria-label="thumbnail-credit"
                                    v-model="editable_thumbnail.credit"
                                />
                            </b-form-group>
                        </div>

                        <div class="col-6">
                            <b-form-group class="h-50">
                                <img
                                    :src="editable_thumbnail.src"
                                    :alt="editable_thumbnail.alt"
                                    class="p-0 mx-auto d-block img-thumbnail link-modal-thumbnail"
                                />
                            </b-form-group>
                        </div>
                    </div>
                    <b-alert v-else variant="danger" show>
                        Thumbnail not set
                    </b-alert>

                    <div class="mt-2">
                        <b-dropdown
                            size="sm"
                            variant="outline-primary"
                            dropdown
                            right
                        >
                            <template #button-content>
                                <font-awesome-icon :icon="['fad', 'plus-square']"/>
                                {{ !hasThumbnail ? 'Add' : 'Change' }} Thumbnail
                            </template>
                            <b-dropdown-item @click.prevent="showSbpMediaModal = true">
                                <font-awesome-icon :icon="['fad', 'plus-square']" class="text-primary" fixed-width/>
                                SBP Media
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </b-form-group>


            </div>
        </b-modal>

        <add-related-media-modal
            v-model="showSbpMediaModal"
            type="image"
            @link="addThumbnailRelatedMedia"
            @hide="showSbpMediaModal = false"
        />
    </div>
</template>

<style lang="scss">
.link-modal-thumbnail {
    max-height: 25vh;
}
</style>

<script>
import AddRelatedMediaModal from '@/components/modals/article/related_media/AddRelatedMediaModal';

export default {
    components: {AddRelatedMediaModal},
    props: {
        visible: Boolean,
        modalData: Object,
    },
    data: () => ({
        editable_name: '',
        editable_url: '',
        editable_thumbnail: null,
        showSbpMediaModal: false,
    }),
    mounted() {
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            if (modalId !== 'link-modal') {
                return
            }

            this.editable_name = ''
            this.editable_url = ''
            this.editable_thumbnail = null
        })
    },
    computed: {
        fieldsFilled() {
            const name = this.editable_name !== undefined && this.editable_name.length !== 0
            const url = this.editable_url !== undefined && this.editable_url.length !== 0

            return name && url && this.hasThumbnail
        },
        hasThumbnail() {
            if (this.editable_thumbnail === null) {
                return false
            }

            return Object.entries(this.editable_thumbnail).length !== 0
        },
    },
    methods: {
        addThumbnailRelatedMedia(relatedMedia) {
            const {
                url,
                alt,
                title,
                credit,
                description,
                caption,
            } = relatedMedia
            this.editable_thumbnail = {
                src: url,
                alt,
                title,
                credit,
                description,
                caption,
            }
            this.showSbpMediaModal = false
        },
        async save() {
            try {
                this.$emit('hide')
                this.$emit('link', {
                    name: this.editable_name,
                    url: this.editable_url,
                    thumbnail: this.editable_thumbnail,
                })
            } catch (e) {

            }
        },
        cancel() {
            this.$emit('hide')
        },
    }
}
</script>
